import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-email",
  "use": "icon-email-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-email\">\r\n  <path d=\"M12,.02a12,12,0,1,0,12,12,12,12,0,0,0-12-12ZM18.99,7,12,12.666,5.009,7H18.99ZM19,17H5V8.495l7,5.673L19,8.5Z\" transform=\"translate(0 -0.02)\" fill=\"currentColor\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol